import { put, takeEvery } from "redux-saga/effects";
import { fetchGraphMethod, fetchMethod } from "../../services/httpService";
import messagePopup from "../../utils/messagePopup";

// ========================================== Action Type =====================================================
export const actionType = {
    COMMITMENT_STATUS_LIST_START: "COMMITMENT_STATUS_LIST_START",
    COMMITMENT_STATUS_LIST_SUCCESS: "COMMITMENT_STATUS_LIST_SUCCESS",
    COMMITMENT_STATUS_LIST_FAILED: "COMMITMENT_STATUS_LIST_FAILED",
};

// ============================================ Actions ========================================================
export const commitmentStatusListStart = (data) => ({
    type: actionType.COMMITMENT_STATUS_LIST_START,
    payload: data,
});

export const commitmentStatusListSuccess = (data) => ({
    type: actionType.COMMITMENT_STATUS_LIST_SUCCESS,
    payload: data,
});

export const commitmentStatusListFailed = (data) => ({
    type: actionType.COMMITMENT_STATUS_LIST_FAILED,
    payload: data,
});

// =========================================== Reducer ===========================================================
const INIT_STATE = {
    loading: false,
    data: null,
    error: null,
};

export default function commitmentStatusListReducer(state = INIT_STATE, action) {
    switch (action.type) {
        case actionType.COMMITMENT_STATUS_LIST_START:
            return {
                ...state,
                loading: true,
            };
        case actionType.COMMITMENT_STATUS_LIST_SUCCESS:
            return {
                ...state,
                loading: false,
                data: action.payload,
                error: null,
            };
        case actionType.COMMITMENT_STATUS_LIST_FAILED:
            return {
                ...state,
                loading: false,
                data: null,
                error: action.payload,
            };
        default:
            return { ...state };
    }
}

// ===================================================== side effect =============================================

export function* commitmentStatusListSaga(action) {
    try {
        const response = yield fetchGraphMethod(action.payload.query, action.payload.variables, true);
        if (response && response.status === 200) {
            const allcommitmentType =  response.data.data.allCommitmentstatuses.Commitmentstatuses
            yield put(commitmentStatusListSuccess(allcommitmentType));
        } else {
            messagePopup("", "State List failed", "error");
            yield put(commitmentStatusListFailed("GPA List failed"));
        }
    } catch (error) {
        messagePopup("", "State List failed", "error");
        yield put(commitmentStatusListFailed("State List failed"));
    }
}

export function* watchCommitmentStatusListSaga() {
    yield takeEvery(actionType.COMMITMENT_STATUS_LIST_START, commitmentStatusListSaga);
}
